module.exports = __webpack_public_path__ + "media/images/lb/078-ba2ea9903b960918cd4c48213e366627.svg";